import { TextInput } from '@mantine/core';
import { useFillOutRevisionDataProvider } from 'components/forms/revision/fill-out/data/FillOutRevisionDataProvider';
import { computeAggregation } from 'components/forms/revision/fill-out/fields/aggregator-utils';
import { RevisionFieldProps } from 'components/forms/revision/fill-out/types';
import { IFormInputSpecDeviceFieldAggregator } from 'pages/revisions-module/template-editor/editors/form/types';
import { useEffect, useMemo } from 'react';

/**
 * Aggregates a particular device field across all devices.
 */
export default function RevisionFieldDeviceFieldAggregator({
  spec,
  name,
}: RevisionFieldProps<IFormInputSpecDeviceFieldAggregator>) {
  const { form } = useFillOutRevisionDataProvider();

  const value = useMemo(() => {
    const deviceValues = Object.values(form.values.devices)
      .filter((device) => !device.removed)
      .map((device) => device.fields[spec.fieldName]);

    return computeAggregation(deviceValues, spec.aggFunc, spec.separator, spec.selectedValue);
  }, [form.values.devices, spec.fieldName, spec.aggFunc, spec.separator, spec.selectedValue]);

  useEffect(() => {
    const { value: currentValue } = form.getInputProps(name);

    if (currentValue !== value) {
      form.setFieldValue(name, value);
    }
  }, [form, name, value]);

  return <TextInput size="lg" required={spec.required} readOnly label={spec.label} {...form.getInputProps(name)} />;
}
